import { AfterViewInit, Component, ComponentRef, OnDestroy, ViewChild, ViewContainerRef } from '@angular/core';
import { XMLElementBaseComponent } from '../base';
import { ToolList } from '../volkswagen.types';
import { ToolImageComponent } from './tool-image.component';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-xml-tool-list',
  standalone: true,
  imports: [ToolImageComponent, TranslocoPipe],
  template: `
    <div class="my-4 max-w-4xl rounded-lg border border-teal-200 bg-teal-50 p-4">
      <div class="mb-3 flex items-center gap-2">
        <i class="pi pi-cog text-teal-600"></i>
        <h4 class="text-sm font-semibold text-teal-800">{{ 'documents.vw.labels.tools' | transloco }}</h4>
      </div>

      <div class="space-y-2">
        <!-- Render image children directly in template -->
        @for (child of imageChildren; track $index) {
          <app-xml-tool-image [data]="child" [provider]="provider"></app-xml-tool-image>
        }

        <!-- Non-image children will be rendered here dynamically -->
        <ng-template #childrenContainer></ng-template>
      </div>
    </div>
  `,
})
export class ToolVwListComponent extends XMLElementBaseComponent<ToolList> implements AfterViewInit, OnDestroy {
  @ViewChild('childrenContainer', { read: ViewContainerRef })
  childrenContainer!: ViewContainerRef;

  private childComponents: ComponentRef<XMLElementBaseComponent>[] = [];

  get imageChildren() {
    return this.data?.children?.filter((child: any) => child.tag === 'bild') || [];
  }

  get nonImageChildren() {
    return this.data?.children?.filter((child: any) => child.tag !== 'bild') || [];
  }

  ngAfterViewInit() {
    if (this.nonImageChildren.length > 0) {
      this.childRenderService.setProvider(this.provider);
      this.childComponents = this.childRenderService.renderChildren(this.nonImageChildren, this.childrenContainer);
    }
  }

  ngOnDestroy() {
    this.childComponents.forEach((ref) => ref.destroy());
  }
}
